import { useApolloClient } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocalStorage } from "usehooks-ts";
import { Button } from "../../../components/ui/button";

function LogoutButton() {
  const { logout } = useAuth0();
  const client = useApolloClient();
  const [, setLatestOrganizationSlug] = useLocalStorage<string | null>(
    "latestOrganizationSlug",
    null
  );

  return (
    <Button
      variant="outline"
      className="w-fit"
      onClick={() => {
        setLatestOrganizationSlug(null);
        logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        }).then(() => client.resetStore());
      }}
    >
      Logout
    </Button>
  );
}

export default LogoutButton;
